<app-menu></app-menu>

<div style="background-color: #f8f9fa;">
    <!-- Hero Section -->
    <div class="fundo uk-light">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
                Sirva seus projectos e dados com <b>gestão facilitada</b> e a <b>menor latência</b>
            </h1>
            <p class="uk-margin-small-top uk-width-2-3@m uk-margin-auto"
                style="font-size: 1.2rem; opacity: 0.9;"
                uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
                Nossa infraestrutura oferece Alta Disponibilidade e nossas soluções de conectividade resiliente para
                garantir
                o máximo desempenho do seu negócio.
            </p>
        </div>
    </div>
</div>

<!-- Pricing Table Section -->
<div class="uk-padding uk-section-muted">
    <div class="uk-container">
        <div class="uk-text-center uk-margin-large-bottom" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            <h2 class="uk-text-bold highlight-text">Escolha o plano perfeito para você</h2>
            <p class="uk-text-large" style="color: #666;">Soluções escaláveis que acompanham o crescimento da sua
                empresa.</p>
        </div>

        <div class="uk-grid uk-grid-match uk-child-width-1-3@m uk-child-width-1-1@s" uk-grid
            uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 200">
            <!-- Fluxo Básico -->
            <div>
                <div class="card-plano">
                    <h3 class="uk-text-bold highlight-text uk-margin-remove">FLUXO BÁSICO</h3>
                    <div class="uk-margin-medium-top uk-margin-medium-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size: 2.5rem; color: #333;">18.000
                            Kz<small style="font-size: 1rem; font-weight: normal; color: #666;"> /ano</small></h2>
                    </div>

                    <div class="uk-text-left uk-margin-small-bottom">
                        <img src="img/cpanel-logo.svg" alt="cPanel" style="max-height: 25px; width: auto;">
                    </div>
                    <ul class="uk-list uk-list-muted uk-text-left" style="flex-grow: 1;">
                        <li><span uk-icon="server" class="uk-margin-small-right highlight-text"></span> <b>10 GB</b> de
                            espaço em <b>SSD</b></li>
                        <li><span uk-icon="rss" class="uk-margin-small-right highlight-text"></span> <b>30 GB</b> de
                            Tráfego mensal</li>
                        <li><span uk-icon="mail" class="uk-margin-small-right highlight-text"></span> <b>5 contas</b> de
                            E-Mail</li>
                        <li><span uk-icon="database" class="uk-margin-small-right highlight-text"></span> <b>2
                                contas</b> FTP</li>
                        <li><span uk-icon="database" class="uk-margin-small-right highlight-text"></span> <b>3 bases de
                                dados</b> SQL</li>
                        <li><span uk-icon="world" class="uk-margin-small-right highlight-text"></span> <b>2
                                subdomínios</b></li>
                    </ul>
                    <a target="_blank"
                        href="https://q28hpkmheelk.upmind.app/order/product?pid=01e96d29-8537-d4e8-6d2a-14e120637085"
                        class="uk-button btn-buy uk-margin-top">
                        <span uk-icon="cart" class="uk-margin-small-right"></span> Comprar Agora
                    </a>
                </div>
            </div>

            <!-- Fluxo Médio (Mais Popular) -->
            <div>
                <div class="card-plano card-plano-premium">
                    <div class="uk-badge uk-position-top-right uk-margin-right uk-margin-top popular-badge">MAIS POPULAR
                    </div>
                    <h3 class="uk-text-bold uk-margin-remove">FLUXO MÉDIO</h3>
                    <div class="uk-margin-medium-top uk-margin-medium-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size: 2.5rem;">62.000 Kz<small
                                style="font-size: 1rem; font-weight: normal; opacity: 0.9;"> /ano</small></h2>
                    </div>

                    <div class="uk-text-left uk-margin-small-bottom">
                        <!-- Logo branca para o card vermelho -->
                        <img src="img/cpanel-logo.svg" alt="cPanel"
                            style="max-height: 25px; width: auto; filter: brightness(0) invert(1);">
                    </div>
                    <ul class="uk-list uk-text-left" style="flex-grow: 1;">
                        <li><span uk-icon="server" class="uk-margin-small-right"></span> <b>50 GB</b> de espaço em
                            <b>SSD</b></li>
                        <li><span uk-icon="rss" class="uk-margin-small-right"></span> <b>100 GB</b> de Tráfego mensal
                        </li>
                        <li><span uk-icon="mail" class="uk-margin-small-right"></span> <b>25 contas</b> de E-Mail</li>
                        <li><span uk-icon="database" class="uk-margin-small-right"></span> <b>5 contas</b> FTP</li>
                        <li><span uk-icon="database" class="uk-margin-small-right"></span> <b>8 bases de dados</b> SQL
                        </li>
                        <li><span uk-icon="world" class="uk-margin-small-right"></span> <b>5 subdomínios</b></li>
                    </ul>
                    <a target="_blank"
                        href="https://q28hpkmheelk.upmind.app/order/product?pid=e2e071d9-31d5-e466-106b-646028758396"
                        class="uk-button btn-buy btn-buy-inverse uk-margin-top">
                        <span uk-icon="cart" class="uk-margin-small-right"></span> Comprar Agora
                    </a>
                </div>
            </div>

            <!-- Fluxo Ilimitado -->
            <div>
                <div class="card-plano">
                    <h3 class="uk-text-bold highlight-text uk-margin-remove">FLUXO ILIMITADO</h3>
                    <div class="uk-margin-medium-top uk-margin-medium-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size: 2.5rem; color: #333;">150.000
                            Kz<small style="font-size: 1rem; font-weight: normal; color: #666;"> /ano</small></h2>
                    </div>

                    <div class="uk-text-left uk-margin-small-bottom">
                        <img src="img/cpanel-logo.svg" alt="cPanel" style="max-height: 25px; width: auto;">
                    </div>
                    <ul class="uk-list uk-list-muted uk-text-left" style="flex-grow: 1;">
                        <li><span uk-icon="server" class="uk-margin-small-right highlight-text"></span> Espaço em <b>SSD
                                ILIMITADO</b></li>
                        <li><span uk-icon="rss" class="uk-margin-small-right highlight-text"></span> Tráfego mensal
                            <b>ILIMITADO</b></li>
                        <li><span uk-icon="mail" class="uk-margin-small-right highlight-text"></span> <b>50 contas</b>
                            de E-Mail</li>
                        <li><span uk-icon="database" class="uk-margin-small-right highlight-text"></span> <b>10
                                contas</b> FTP</li>
                        <li><span uk-icon="database" class="uk-margin-small-right highlight-text"></span> <b>10 bases de
                                dados</b> SQL</li>
                        <li><span uk-icon="world" class="uk-margin-small-right highlight-text"></span> <b>15
                                subdomínios</b></li>
                    </ul>
                    <a target="_blank"
                        href="https://q28hpkmheelk.upmind.app/order/product?pid=5196e02e-5136-d427-3d8f-0429807875d3"
                        class="uk-button btn-buy uk-margin-top">
                        <span uk-icon="cart" class="uk-margin-small-right"></span> Comprar Agora
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- Why Choose Us -->
<div class="uk-section uk-section-default">
    <div class="uk-container">
        <div class="uk-grid uk-flex-middle" uk-grid>
            <div class="uk-width-2-5@m" uk-scrollspy="cls: uk-animation-slide-left-small; delay: 100">
                <h2 class="uk-text-bold highlight-text">Por que escolher a nossa hospedagem?</h2>
                <p class="uk-text-large" style="color: #444; line-height: 1.6;">
                    A nossa hospedagem utiliza a tecnologia <b>cPanel</b>, ideal para quem busca controle total sobre
                    e-mails, domínios, arquivos e bancos de dados.
                </p>
                <p style="color: #666;">
                    Garantimos estabilidade, segurança avançada e o melhor suporte para projectos de todos os tamanhos.
                </p>
                <div class="uk-margin-medium-top uk-flex uk-flex-middle">
                    <img src="img/cpanel-whm.png" alt="cPanel & WHM" style="max-height: 60px;">
                    <div class="uk-margin-left uk-text-small uk-text-muted">Certificado oficial de parceria</div>
                </div>
            </div>
            <div class="uk-width-3-5@m" uk-scrollspy="cls: uk-animation-slide-right-small; target: > div; delay: 200">
                <div class="uk-grid uk-grid-small uk-child-width-1-2@s" uk-grid>
                    <div>
                        <div class="feature-card">
                            <div class="feature-icon-box"><img src="img/backup.png" alt="Backup"></div>
                            <h4 class="uk-text-bold">Backup Diário</h4>
                            <p class="uk-text-small uk-margin-remove">Suas informações seguras com cópias automáticas
                                todos os dias.</p>
                        </div>
                    </div>
                    <div>
                        <div class="feature-card">
                            <div class="feature-icon-box"><img src="img/suport.png" alt="Suporte"></div>
                            <h4 class="uk-text-bold">Suporte 24/7</h4>
                            <p class="uk-text-small uk-margin-remove">Nossa equipe está pronta para ajudar você a
                                qualquer hora.</p>
                        </div>
                    </div>
                    <div>
                        <div class="feature-card">
                            <div class="feature-icon-box"><i class="fa-solid fa-coins feature-icon"></i></div>
                            <h4 class="uk-text-bold">Pagamento Local</h4>
                            <p class="uk-text-small uk-margin-remove">Aceitamos Kwanza (Kz) sem taxas de conversão ou
                                surpresas.</p>
                        </div>
                    </div>
                    <div>
                        <div class="feature-card">
                            <div class="feature-icon-box"><img src="img/infra.png" alt="Infra"></div>
                            <h4 class="uk-text-bold">Infraestratura Local</h4>
                            <p class="uk-text-small uk-margin-remove">Servidores em Angola para garantir a menor
                                latência do mercado.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- App Installer Section -->
<div class="app-installer-section">
    <div class="uk-container uk-text-center">
        <h2 class="uk-text-bold uk-margin-remove-bottom" style="color: #ffffff;"
            uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">Comece seu projecto em apenas um clique</h2>
        <p class="uk-margin-small-top uk-margin-large-bottom" style="color: #ffffff;"
            uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">Instale as melhores tecnologias do mercado
            de forma rápida e segura.</p>

        <div class="uk-grid uk-grid-match uk-child-width-1-4@l uk-child-width-1-2@s" uk-grid
            uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 200">
            <div>
                <div class="app-card">
                    <i class="fa-brands fa-node-js app-icon js-color"></i>
                    <h4 class="uk-text-bold">Node.js</h4>
                    <p>Hospede aplicações de alta performance com processamento em tempo real.</p>
                </div>
            </div>
            <div>
                <div class="app-card">
                    <img src="img/laravel.png" alt="Laravel" class="app-icon">
                    <h4 class="uk-text-bold">Laravel</h4>
                    <p>Ideal para sistemas PHP modernos, robustos e com grande escalabilidade.</p>
                </div>
            </div>
            <div>
                <div class="app-card">
                    <img src="img/wordpress.png" alt="WordPress" class="app-icon">
                    <h4 class="uk-text-bold">WordPress</h4>
                    <p>A maior plataforma do mundo otimizada para o seu blog ou site institucional.</p>
                </div>
            </div>
            <div>
                <div class="app-card">
                    <img src="img/joomla.png" alt="Joomla" class="app-icon">
                    <h4 class="uk-text-bold">Joomla</h4>
                    <p>Perfeito para gestão flexível de conteúdos complexos e portais corporativos.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<app-rodape></app-rodape>